/** Incrémenter + reset local si hydrate voit une version inférieure (voir useAppStore). */
export const PERSIST_SCHEMA_VERSION = 2;
